<label class="inline-flex items-center cursor-pointer">
  <input
    #checkbox
    type="checkbox"
    value=""
    class="sr-only peer"
    (change)="handleToggleChange($event)"
    [checked]="isChecked"
  />
  <div
    class="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-purple-200 after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"
    [ngClass]="{
      'bg-primary after:translate-x-full': isChecked,
      'bg-gray-200 after:translate-x-0': !isChecked
    }"
  ></div>
  @if(label()){
  <span class="ms-3 text-sm font-medium text-gray-900">{{ label() }}</span>
  }
</label>
